function Left(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M6.828 25l1.156 1.328 11 12.5L22 36.172 12.172 25 22 13.828l-3.016-2.656-11 12.5L6.828 25z"
          fill="#4079F5"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="rotate(90 15 15)" d="M0 0h50v30H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Left
